import React from 'react';
import './App.scss';
import Particle from './components/particle/particle';

function App() {
  return (
    <div className="App">
      <div className="info">
        Thomas Henriksson
        <div>
          <a className="lab la-github" href="https://github.com/thohe973"></a>
          <a className="lab la-linkedin-in" href="https://se.linkedin.com/in/thohe"></a>
        </div>
      </div>
      <Particle></Particle>
    </div>
  );
}

export default App;
